import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type { CommandDto, CommandListRequest, CreateCommandRequest } from '@/types/command';

export const commandsApi = {
  list(request: CommandListRequest = {}): Promise<PagedResult<CommandDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<CommandDto>>>('/commands', { params: request }));
  },
  getById(id: number): Promise<CommandDto> {
    return unwrap(apiClient.get<ApiResponse<CommandDto>>(`/commands/${id}`));
  },
  create(request: CreateCommandRequest): Promise<CommandDto> {
    return unwrap(apiClient.post<ApiResponse<CommandDto>>('/commands', request));
  },
  cancel(id: number): Promise<void> {
    return apiClient.post(`/commands/${id}/cancel`).then(() => undefined);
  },
};
